import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TabsPage } from './tabs.page';

@NgModule({
  imports: [IonicModule, CommonModule],
  declarations: [TabsPage],
})
export class TabsPageModule {}
